import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';
import { ObjectWithId } from '@synergy/models';
import { noop } from '@synergy/utils';

import { PaymentTerm } from '../models/payment-term';

export class PaymentTermsApi {
    constructor(protected baseUrl: string) {}

    public cget = async (params?: URLSearchParams): Promise<ApiResult<PaginatedResponse<PaymentTerm>>> => {
        return safeRequest(
            () => request.get(`${this.baseUrl}/payment-terms`, { params }),
            response => response.data
        );
    };

    public cgetAll = async (params: URLSearchParams): Promise<ApiResult<PaymentTerm[]>> => {
        return safeRequest(
            () => request.get(`${this.baseUrl}/all-payment-terms`, { params }),
            response => response.data
        );
    };

    public updatePaymentTerm = async (
        paymentTerm: Partial<PaymentTerm> & ObjectWithId
    ): Promise<ApiResult<PaymentTerm>> => {
        return safeRequest(
            () => request.patch(`${this.baseUrl}/payment-terms/${paymentTerm.id}`, paymentTerm),
            response => response.data
        );
    };

    public createPaymentTerm = async (paymentTerm: Partial<PaymentTerm>): Promise<ApiResult<PaymentTerm>> => {
        return safeRequest(
            () => request.post(`${this.baseUrl}/payment-terms`, paymentTerm),
            response => response.data
        );
    };

    public deletePaymentTerm = async (paymentTermId: number): Promise<ApiResult<void>> => {
        return safeRequest(() => request.delete(`${this.baseUrl}/payment-terms/${paymentTermId}`), noop);
    };
}
